import { useEffect, useRef } from "react";
import { ToolBtn } from "./text-btn";

export const PlainTextEditor: React.FC<{
  value: string;
  onChange: (val: string) => void;
}> = ({ value, onChange }) => {
  const ref = useRef<HTMLDivElement>(null);

  const exec = (cmd: string, val?: string) => {
    document.execCommand(cmd, false, val);
    ref.current?.focus();
  };

  const handleInput = () => {
    if (ref.current) onChange(ref.current.innerHTML);
  };

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== value) {
      ref.current.innerHTML = value;
    }
  }, [value]);

  return (
    <div className="flex flex-col flex-1 border border-gray-200 rounded-lg overflow-hidden">
      <div className="flex items-center gap-1 px-3 py-2 border-b border-gray-100 bg-gray-50 flex-wrap">
        <ToolBtn title="Bold" onClick={() => exec("bold")}><b>B</b></ToolBtn>
        <ToolBtn title="Italic" onClick={() => exec("italic")}><i>I</i></ToolBtn>
        <ToolBtn title="Underline" onClick={() => exec("underline")}><u>U</u></ToolBtn>
        <ToolBtn title="Strikethrough" onClick={() => exec("strikeThrough")}><s>A</s></ToolBtn>
        <div className="w-px h-4 bg-gray-200 mx-1" />
        <ToolBtn title="Align Left" onClick={() => exec("justifyLeft")}>⬅</ToolBtn>
        <ToolBtn title="Align Center" onClick={() => exec("justifyCenter")}>↔</ToolBtn>
        <ToolBtn title="Align Right" onClick={() => exec("justifyRight")}>➡</ToolBtn>
        <ToolBtn title="Justify" onClick={() => exec("justifyFull")}>☰</ToolBtn>
        <div className="w-px h-4 bg-gray-200 mx-1" />
        <ToolBtn title="Ordered List" onClick={() => exec("insertOrderedList")}>1.</ToolBtn>
        <ToolBtn title="Unordered List" onClick={() => exec("insertUnorderedList")}>•</ToolBtn>
        <ToolBtn title="Outdent" onClick={() => exec("outdent")}>⇤</ToolBtn>
        <ToolBtn title="Indent" onClick={() => exec("indent")}>⇥</ToolBtn>
        <div className="w-px h-4 bg-gray-200 mx-1" />
        <ToolBtn
          title="Link"
          onClick={() => {
            const url = prompt("Enter URL:");
            if (url) exec("createLink", url);
          }}
        >
          🔗
        </ToolBtn>
      </div>

      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        className="flex-1 p-4 text-sm text-gray-800 outline-none min-h-[380px] overflow-y-auto"
        data-placeholder="Type your message"
        style={{ lineHeight: 1.6 }}
      />
      <style>{`
        [contenteditable]:empty:before {
          content: attr(data-placeholder);
          color: #9ca3af;
          pointer-events: none;
        }
      `}</style>
    </div>
  );
};